var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtml5Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_392_268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.04688 36.4375L2.84375 0.5H38.0781L34.875 36.4375L20.4219 40.5",
    fill: "#E34F26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 37.375L32.1406 34.1719L34.875 3.39062H20.5",
    fill: "#EF652A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 16.75H14.6406L14.25 12.2188H20.5V7.84375H20.4219H9.40625L9.48438 9.01562L10.5781 21.2031H20.5V16.75ZM20.5 28.2344H20.4219L15.5 26.9062L15.1875 23.3906H12.8438H10.8125L11.3594 30.3438L20.4219 32.8438H20.5V28.2344Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4219 16.75V21.2031H25.8906L25.3438 26.9062L20.4219 28.2344V32.8438L29.4844 30.3438L29.5625 29.5625L30.5781 17.9219L30.7344 16.75H29.4844H20.4219ZM20.4219 7.84375V10.5781V12.2188H31.125L31.2031 11.2812L31.4375 9.01562L31.5156 7.84375H20.4219Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_392_268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5Logo);
export default __webpack_public_path__ + "static/media/html-5-logo.a5c402aff365b64344faa0369e46c082.svg";
export { ForwardRef as ReactComponent };